import viewSlice from './slice';

export const { parseWindow } = viewSlice.actions;
